import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from '../icons/SalesIcons';
interface CTAButtonProps {
  text: string;
  variant?: 'primary' | 'secondary';
  size?: 'lg' | 'md';
  fullWidth?: boolean;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  onClick,
  className = ''
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-3 font-bold uppercase tracking-wide rounded-lg transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-[#C4A882]/50';
  const sizeStyles = {
    lg: 'px-8 py-4 text-base md:text-lg',
    md: 'px-6 py-3 text-sm md:text-base'
  };
  const variantStyles = {
    primary: 'bg-gradient-to-r from-[#9B2335] to-[#7a1c2a] text-white border-2 border-[#C4A882] shadow-lg shadow-[#9B2335]/30',
    secondary: 'bg-transparent text-[#9B2335] border-2 border-[#C4A882]'
  };
  return <motion.button onClick={onClick ?? (() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'Ilumina y Crea - Curso de Velas Artesanales',
        content_type: 'product',
        value: 52.49,
        currency: 'USD'
      });
    }
    window.open('https://go.hotmart.com/D96651236E?ap=20c3&offDiscount=ILUMINA25', '_blank');
  })} className={`
        ${baseStyles}
        ${sizeStyles[size]}
        ${variantStyles[variant]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} whileHover={{
    scale: 1.02,
    boxShadow: variant === 'primary' ? '0 0 30px rgba(155, 35, 53, 0.5), 0 0 60px rgba(196, 168, 130, 0.3)' : '0 0 20px rgba(196, 168, 130, 0.3)'
  }} whileTap={{
    scale: 0.98
  }} animate={variant === 'primary' ? {
    boxShadow: ['0 10px 30px rgba(155, 35, 53, 0.3)', '0 10px 40px rgba(155, 35, 53, 0.5)', '0 10px 30px rgba(155, 35, 53, 0.3)']
  } : {}} transition={variant === 'primary' ? {
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  } : {}} data-id="element-410">
      <span data-id="element-411">{text}</span>
      <ArrowRightIcon size={20} className="flex-shrink-0" data-id="element-412" />
    </motion.button>;
}